import { requestApiGet } from "../api/BacklogApiEndpoint";
import type { BacklogConfig } from "../contracts/BacklogConfig";
import type { BacklogApiContext } from "../contracts/api/BacklogApiContext";
import type { BacklogResponse } from "../contracts/api/BacklogResponse";
import type { Licence } from "../entities/Licence";

/**
 * Get Licence ライセンス情報の取得
 *
 * Returns licence.
 */
export function getLicence(
	config: BacklogConfig,
	context?: BacklogApiContext,
): Promise<BacklogResponse<Licence>> {
	return requestApiGet({
		config,
		path: "space/licence",
		params: undefined,
		context,
	});
}
